G.featureUnlock = { // The rest of the settings are at other-match3-engine\js\Config\featureUnlockDefault.js
  shoutoutAudio: true, // Shoutouts have audio?
  requestMoveHelp: true,
  eventPostcard: {
    enabled: false,
    range: {
      start: 1581552000000, // Feb 13, 2020 00:00:00 UTC
      end: 1582243200000, // Feb 21, 2020 00:00:00 UTC
    },
  },
  friendshipChest: { // Friendship chest
    enabled: false,
    storyMode: true, // Have normal friendship chest or story mode
  },
};
